"use client"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { useTranslations } from "next-intl"


export function ToolWorkingHoursSetting({ checked, onCheckedChange, disabled = false, id }: {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  id: string
}) {
  const tUi = useTranslations("AgentTasks.AgentTasksToolWorkingHoursSetting")

  return (
    <div className="flex items-center gap-3 rounded-md border p-3">
      <Checkbox id={id} checked={checked} disabled={disabled}
        onCheckedChange={value => onCheckedChange(value === true)} />
      <div className="space-y-1">
        <Label htmlFor={id}><span key={tUi("keepThisTaskInsideOrganizationWorkingHours")}>{tUi("keepThisTaskInsideOrganizationWorkingHours")}</span></Label>
        <p className="text-xs text-muted-foreground">
          <span key={tUi("whenEnabledTasksRequestedOutsideTheOrganizationS")}>{tUi("whenEnabledTasksRequestedOutsideTheOrganizationS")}</span></p>
      </div>
    </div>
  )
}
